import './App.css';
import "tailwindcss/tailwind.css"
import { Header } from './components/Header';
import { Hero } from './components/Hero/Hero.jsx';
import {AboutUs} from "./components/About Us/AboutUs";
import {MetaTags} from 'react-meta-tags'
import {Footer} from "./components/Footer";
import Rules from "./components/Rules/Rules";
import {Features} from "./components/Features/Features";
import React,{useRef} from 'react'
import {TryGame} from "./components/TryGame/TryGame";
import {QuestionContextProvider} from "./context/QuestionContext";


function App() {
    const aboutUsRef = useRef()
    const rulesRef = useRef()
    const featuresRef = useRef()
    const tryGameRef = useRef()

    return (
    <div className="App">
        <MetaTags>
            <title>Super Over | Cricket Trivia</title>
        </MetaTags>

      <Header aboutUs={aboutUsRef} rules={rulesRef} features={featuresRef} tryGame={tryGameRef}  />

      <Hero  />


        <div ref={rulesRef}>
            <Rules />
        </div>

        <div ref={featuresRef}>
            <Features />
        </div>
        <div ref={tryGameRef}>
            <QuestionContextProvider>
                <TryGame  />
            </QuestionContextProvider>

        </div>
        <AboutUs myRef={aboutUsRef} />
        <Footer aboutUs={aboutUsRef} rules={rulesRef} features={featuresRef} tryGame={tryGameRef}  />

    </div>
  );
}

export default App;
